/**
 * Subtle ambient orbs — deep navy + orange radial blobs that softly float
 * behind the whole page. Purely decorative, non-interactive.
 */
export const BackgroundOrbs = () => {
    return (
        <div
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
        >
            <div
                className="noxn-orb noxn-orb--a"
                style={{
                    top: "-10%",
                    left: "-8%",
                    width: "520px",
                    height: "520px",
                    background:
                        "radial-gradient(circle at 30% 30%, rgba(255, 90, 0, 0.35), rgba(255, 90, 0, 0) 60%)",
                }}
            />
            <div
                className="noxn-orb noxn-orb--b"
                style={{
                    top: "40%",
                    right: "-15%",
                    width: "620px",
                    height: "620px",
                    background:
                        "radial-gradient(circle at 40% 60%, rgba(56, 122, 240, 0.22), rgba(56, 122, 240, 0) 60%)",
                }}
            />
            <div
                className="noxn-orb noxn-orb--a"
                style={{
                    bottom: "-15%",
                    left: "35%",
                    width: "480px",
                    height: "480px",
                    background:
                        "radial-gradient(circle at 50% 50%, rgba(255, 90, 0, 0.14), rgba(255, 90, 0, 0) 65%)",
                    animationDelay: "3s",
                }}
            />
        </div>
    );
};
